module.exports = __webpack_public_path__ + "img/michelle-obama-medium.6d7bb3c5.jpg";